export default __webpack_public_path__ + "static/media/individualAttention.f908fc64.svg";